import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {KeHoachNguoiDoc} from '../../models/kehoach/kehoachnguoidoc';
import {catchError, map} from 'rxjs/operators';
import {environment} from '../../../environments/environment';
import {Message} from '../../models/danhmuc/message';
import {ThongBaoNguoiDoc} from '../../models/info/thongbaonguoidoc';
const apiUrl = `${environment.apiUrl}/api/info/kehoachnguoidoc`;

@Injectable({
  providedIn: 'root'
})
export class KeHoachNguoiDocService {
  constructor(public httpService: HttpClient) { }

  public getAll(): Observable<KeHoachNguoiDoc[]> {
    return this.httpService.get<KeHoachNguoiDoc[]>(`${apiUrl}/getall`).pipe(
      map(data => data.map(data => new KeHoachNguoiDoc().deserialize(data)))
    );
  }
  public add(params: Object): Observable<KeHoachNguoiDoc>
  {
    return this.httpService.post(`${apiUrl}/add`, params).pipe(
      map(data => new KeHoachNguoiDoc().deserialize(data)));

  }
  findAllByKeHoachId(id: number): Observable<KeHoachNguoiDoc[]> {
    return this.httpService.get<KeHoachNguoiDoc[]>(`${apiUrl}/getallbykehoachid/${id}`).pipe(
      map(data => data.map(data => new KeHoachNguoiDoc().deserialize(data)))
    );
  }
  public update(params: Object): Observable<KeHoachNguoiDoc>
  {
    return this.httpService.post(`${apiUrl}/update`, params).pipe(
      map(data => new KeHoachNguoiDoc().deserialize(data)));

  }
  public addMulti(id: number, sid: string)
  {
    return this.httpService.get(`${apiUrl}/addmulti/${id}?sid=${sid}`).pipe(
      map(data => Number(data)));

  }
  public getCountByKeyword(keyword: string)
  {
    return this.httpService.get(`${apiUrl}/getcountbykeyword?keyword=${keyword}`).pipe(
      map(data => Number(data)));
  }
  public getById(id: number): Observable<KeHoachNguoiDoc>
  {
    return this.httpService.get<KeHoachNguoiDoc>(`${apiUrl}/findbyid/${id}`).pipe(
      map(data => new KeHoachNguoiDoc().deserialize(data)),
      catchError(() => throwError('items not found'))
    );
  }
  public delete(id: number): Observable<Message>
  {
    return this.httpService.get<Message>(`${apiUrl}/delete/${id}`).pipe(
      map(data => new Message().deserialize(data)),
      catchError(() => throwError('id delete not found'))
    );
  }
  findByKeyword(keyword: String): Observable<KeHoachNguoiDoc[]> {
    return this.httpService.get<KeHoachNguoiDoc[]>(`${apiUrl}/findbykeyword?keyword=${keyword}`).pipe(
      map(data => data.map(data => new KeHoachNguoiDoc().deserialize(data)))
    );
  }
  findAllByPaging(keyword: String, page: number, size: number): Observable<KeHoachNguoiDoc[]> {
    return this.httpService.get<KeHoachNguoiDoc[]>(`${apiUrl}/getallpaging?key=${keyword}&page=${page}&size=${size}`).pipe(
      map(data => data.map(data => new KeHoachNguoiDoc().deserialize(data)))
    );
  }
}
